<template>
  <div>
    <Alert
      class="margin-bottom-16"
      variant="light-warning"
      rightIcon="alert"
      :text="$lang.centerExecuteSetAbsentInfoMessage"
    />
    <Input
      :title="`${$lang.absentReason} (${$lang.optional})`"
      :placeholder="$lang.absentReason"
      :value="form.absentReason"
      name="absentReason"
      id="absentReason"
      type="textarea"
      :minLength="lengthNumber3"
      :maxLength="lengthNumber256"
      :vuelidateObj="$v.form.absentReason"
      @input="input"
      @focus="resetValidation"
      @blur="checkValidation"
    />
    <div class="flex-end">
      <Button
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="handleClose"
      />
      <Button
        class="margin-right-8"
        contentClass="justify-content-center"
        variant="filled-error"
        :text="$lang.setAbsent"
        :loading="loading"
        @click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Alert } from "@/components/re-design";
import { Input, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { generateError, toastAlert } from "@/shared/utils";
import { setCenterExecuteAbsent } from "@/modules/kanoon/services";
export default {
  mixins: [inputMixin],
  inject: ["CENTER_EXECUTE_DATA", "handleReloadList"],
  components: { Alert, Input, Button },
  props: {
    personId: {
      type: [Number, String],
      default: null,
    },
  },
  validations() {
    return {
      form: {
        absentReason: {},
      },
    };
  },
  data() {
    return {
      form: {
        absentReason: null,
      },
      loading: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const { id: centerExecuteId } = this.CENTER_EXECUTE_DATA;
        const { absentReason } = this.form;

        const response = await setCenterExecuteAbsent(
          centerExecuteId,
          this.personId,
          absentReason
        );
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.handleReloadList();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
